import axios from 'axios'
import { UPDATE_CHECK_INTERVAL } from 'common'
import { useEffect, useRef, useState } from 'react'
import { useLocation } from 'react-router'

declare const __COMMIT_HASH__: string

const pagesToReload: string[] = [
  '/home',
  '/orderHistory',
  '/cart',
  '/quotes',
  '/lists',
  '/vehicleHistory',
  '/login',
  '/sendCode',
  '/orderConfirmation',
]

// Checks if an update is available by comparing the last commit hash of the app.
const isUpdateAvailable = (): Promise<boolean> => {
  const currentVersion = __COMMIT_HASH__

  return axios
    .get('/manifest.json', {
      params: {
        timestamp: new Date().getTime(),
      },
    })
    .then((response) => {
      const deployedVersion = response.data.version
      return Boolean(deployedVersion) && currentVersion !== deployedVersion
    })
    .catch(() => false)
    .finally(() => false)
}

// Hook used to trigger reload if updates are available.
export const useUpdateCheck = (): void => {
  const { pathname } = useLocation()
  const [updateAvailable, setUpdateAvailable] = useState(false)

  useEffect(() => {
    const checkUpdate = () => {
      if (updateAvailable) return
      isUpdateAvailable().then((available) => {
        if (available) {
          setUpdateAvailable(true)
          clearInterval(interval)
        }
      })
    }

    checkUpdate()
    const interval = setInterval(checkUpdate, UPDATE_CHECK_INTERVAL)
    return () => clearInterval(interval)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const previousPathname = useRef(pathname)

  useEffect(() => {
    if (pathname === previousPathname.current) return
    previousPathname.current = pathname

    if (updateAvailable && pagesToReload.includes(pathname)) {
      window.location.reload()
    }
  }, [updateAvailable, pathname])
}
